import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { getEnergySettings, updateEnergySettings } from '@/backend/services/energySettings';
import type { EnergySettings } from '@/backend/services/energySettings';

export function useEnergySettings() {
  return useQuery({
    queryKey: ['energy-settings'],
    queryFn: getEnergySettings,
    staleTime: 5 * 60 * 1000,
  });
}

export function useUpdateEnergySettings() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (data: Partial<EnergySettings>) => updateEnergySettings(data),
    onSuccess: (_, variables) => {
      queryClient.setQueryData<EnergySettings>(['energy-settings'], (old) =>
        old ? { ...old, ...variables } : (variables as EnergySettings)
      );
      queryClient.invalidateQueries({ queryKey: ['energy-settings'] });
    },
  });
}
